/**
 * 健康指标主题（与 /static/icon/*.svg 品牌色对齐）
 * color：类型标识色，不表示正常/异常状态
 */
export const METRIC_DEFS = [
  { type: 0, color: '#FF5733', icon: '/static/icon/xinlv.svg', labelKey: 'xin-shuai' },
  { type: 1, color: '#00BAAD', icon: '/static/icon/tiwen.svg', labelKey: 'ti-wen' },
  { type: 2, color: '#FF8D1A', icon: '/static/icon/xueya.svg', labelKey: 'xie-ya' },
  { type: 3, color: '#41C2FC', icon: '/static/icon/xueyang.svg', labelKey: 'xie-yang' },
  { type: 4, color: '#FFC300', icon: '/static/icon/xuetang.svg', labelKey: 'xie-tang' },
  { type: 6, color: '#807CF5', icon: '/static/icon/shuimian.svg', labelKey: 'shui-mian' }
]

/** 报警弹窗：四大核心生命体征字段映射 */
export const ALARM_CORE_METRICS = [
  { type: 0, valueKey: 'heart_rate', abnormalKey: 'heart_rate_abnormal', timeKey: 'heart_rate_time' },
  { type: 1, valueKey: 'temperature', abnormalKey: 'temperature_abnormal', timeKey: 'temperature_time' },
  { type: 2, bp: true, abnormalKey: 'bp_abnormal', timeKey: 'bp_time' },
  { type: 3, valueKey: 'blood_oxygen', abnormalKey: 'blood_oxygen_abnormal', timeKey: 'blood_oxygen_time' }
]

const METRIC_MAP = METRIC_DEFS.reduce((acc, def) => {
  acc[def.type] = def
  return acc
}, {})

export function getMetricDef (type) {
  return METRIC_MAP[type] || null
}



// WEBPACK FOOTER //
// ./src/utils/healthMetricTheme.js